import { executeRequest, JFSRequest } from '@jfs/network'
import { getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (data: any) => {
  return {
    bankName: data?.bankName,
    entityCode: data?.entityCode,
    entityId: getIdFromMap(data?.entityId),
    rpslCode: data?.rpslCode,
    status: data?.status === 'Enable',
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addNetbanking = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addNBMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addNetbanking }
